export const iconFontAwesomeEnergyOilWell = (
	<i className="fa-solid fa-oil-well"></i>
);
